import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { GET_ONE, Button } from "react-admin";
import dataProviderFactory from "../dataProvider";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Info from "@material-ui/icons/Info";
import Print from "@material-ui/icons/Print";
import { isNil, head, filter, map, isEmpty } from "ramda";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import ReactToPrint from "react-to-print";

const StyledH3 = styled.h3({
  color: "#ff9800",
  textTransform: "uppercase",
  paddingBottom: "15px"
});

const StyledGridHeader = styled(Grid)({
  padding: "5px",
  backgroundColor: "#ff9800",
  color: "#000000",
  textTransform: "uppercase"
});

const StyledGridElement = styled(Grid)({
  padding: "5px",
  color: "#000000",
  fontSize: "13px"
});

class ClientInformationButton extends Component {
  async fetchData(ids) {
    const dataProvider = await dataProviderFactory("rest");
    const results = await Promise.all(
      ids.map(async id => dataProvider(GET_ONE, "clients", { id }))
    );

    return results.reduce((acc, elem) => {
      acc.push(elem.data);
      return acc;
    }, []);
  }

  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  state = {
    data: null,
    error: false,
    showDialog: false
  };

  async componentDidUpdate() {
    if (this.state.showDialog && isNil(this.state.data)) {
      const id = this.props.clientIds;
      await this.updateState(id);
    }
  }

  async componentDidMount() { }

  updateState = async id => {
    const data = await this.fetchData(id);
    this.setState({ data });
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, data: null });
  };

  renderTours = client => {
    const toursDone = filter(this.isBeforeToday, client.rentals);

    if (!isEmpty(toursDone)) {
      return (
        <React.Fragment>
          <h3>Tours List</h3>
          <Grid container spacing={0}>
            <Grid container spacing={0} xs={12}>
              <StyledGridHeader item xs={1}>
                Id
              </StyledGridHeader>
              <StyledGridHeader item xs={5}>
                Tour
              </StyledGridHeader>
              <StyledGridHeader item xs={2}>
                First Name
              </StyledGridHeader>
              <StyledGridHeader item xs={2}>
                Last Name
              </StyledGridHeader>
              <StyledGridHeader item xs={2}>
                Vehicle
              </StyledGridHeader>
            </Grid>
            {map(rental => {
              return (
                <Grid container spacing={0} xs={12}>
                  <StyledGridElement item xs={1}>
                    {rental.id}
                  </StyledGridElement>
                  <StyledGridElement item xs={5}>
                    {rental.booking.tour.tour_name.tour_name_en} --{" "}
                    {moment(rental.booking.tour.tour_start_date).format(
                      "MMM D"
                    )}
                    -
                    {moment(rental.booking.tour.tour_end_date).format("D YYYY")}
                  </StyledGridElement>
                  <StyledGridElement item xs={2}>
                    {rental.booking.r_first_name}
                  </StyledGridElement>
                  <StyledGridElement item xs={2}>
                    {rental.booking.r_last_name}
                  </StyledGridElement>
                  <StyledGridElement item xs={2}>
                    {head(rental.vehicle).model.model_name} -{" "}
                    {head(rental.vehicle).licence_plate} {head(rental.vehicle).renting ? "®" : ""}
                  </StyledGridElement>
                </Grid>
              );
            }, toursDone)}
          </Grid>
        </React.Fragment>
      );
    }
    return "";
  };

  renderContent = clientsData => {
    if (!isNil(clientsData)) {
      return (
        <React.Fragment>
          {clientsData.map(data => (
            <Fragment>
              <p>
                <b>Client Name:</b> {data.client_first_name}{" "}
                {data.client_last_name}{" "}
              </p>
              <p>
                <b>Client Nickname:</b> {data.nickname != null ? data.nickname : ''}
              </p>
              <p>
                <b>Client Age / Birth Date:</b>{" "}
                {moment().diff(moment(data.client_birth_date), "years")} (
                {moment(data.client_birth_date).format("YYYY-MM-DD")})
              </p>
              <p>
                <b>Client Own Bike:</b>{" "}
                {head(data.rentals).booking.r_own_bike ? "Yes" : "No"}{" "}
                {head(data.rentals).booking.r_own_bike &&
                  head(data.rentals).booking.r_own_models
                  ? `(${head(data.rentals).booking.r_own_models})`
                  : ""}
              </p>
              {this.renderTours(data)}
              <hr />
              <br />
            </Fragment>
          ))}
        </React.Fragment>
      );
    }

    return "";
  };

  isBeforeToday = t => {
    return (
      !isNil(t.booking.tour) &&
      moment(t.booking.tour.tour_end_date).isBefore(moment())
    );
  };

  render() {
    const { showDialog, data: clientsData } = this.state;
    return (
      <Fragment>
        <Info
          titleAccess="CLIENT INFORMATION"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Client Information"
        >
          <DialogContent ref={this.componentRef}>
            <StyledH3>CLIENTS INFORMATION</StyledH3>
            {this.renderContent(clientsData)}
          </DialogContent>
          <DialogActions>
            <ReactToPrint
              trigger={() => (
                <Button color="primary" onClick={this.nextClick} label="Print">
                  <Print />
                </Button>
              )}
              content={() => this.componentRef.current}
            />
            <Button label="Close" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientInformationButton);



// WEBPACK FOOTER //
// ./src/components/clientInformation.js